import { r as read } from "../../../../chunks/index3.js";
const icon = "/_app/immutable/assets/icon.CsSxoVHt.png";
const GET = () => {
  return read(icon);
};
export {
  GET
};
